import { AnimationStep } from "./animationStep.model";

export class Animation{  
    constructor(JSONString){
        let parsedJSON = JSON.parse(JSONString);
        this.animationName = parsedJSON.animationName;
        this.steps = [];
    }
}